module.exports = __webpack_public_path__ + "media/src/images/progress/dentals_2-21f46a893a5a8dd04a5cec7231fb8b25.jpg";